
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.alert-body{
  display:block;
  border-width:0;
  border-left-width:8px;
  border-style:solid;
  padding:1rem;
}

.alert-header{
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  font-weight:var(--fw-bold);
  text-transform:capitalize;
}

:host([statusType='info']) .alert-body{
  background-color:var(
    --outline-alert-info-background,
    var(--outline-alert--default-info-background)
  );
  border-color:var(
    --outline-alert-info-border,
    var(--outline-alert--default-info-border)
  );
  color:var(
    --outline-alert-info-text,
    var(--outline-alert--default-info-text)
  );
}

:host([statusType='warning']) .alert-body{
  background-color:var(
    --outline-alert-warning-background,
    var(--outline-alert--default-warning-background)
  );
  border-color:var(
    --outline-alert-warning-border,
    var(--outline-alert--default-warning-border)
  );
  color:var(
    --outline-alert-warning-text,
    var(--outline-alert--default-warning-text)
  );
}

:host([statusType='error']) .alert-body{
  background-color:var(
    --outline-alert-error-background,
    var(--outline-alert--default-error-background)
  );
  border-color:var(
    --outline-alert-error-border,
    var(--outline-alert--default-error-border)
  );
  color:var(
    --outline-alert-error-text,
    var(--outline-alert--default-error-text)
  );
}

:host([statusType='success']) .alert-body{
  background-color:var(
    --outline-alert-success-background,
    var(--outline-alert--default-success-background)
  );
  border-color:var(
    --outline-alert-success-border,
    var(--outline-alert--default-success-border)
  );
  color:var(
    --outline-alert-success-text,
    var(--outline-alert--default-success-text)
  );
}
`;